import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BaseUrl } from "../helper/BaseUrl";
import { toast } from "react-toastify";
import { useModal } from "../contexts/ModalContext";
export default function Footer() {
  const { openQueryModal } = useModal();
  const { pathname } = useLocation();

  const [show, setShow] = useState(false);
  const [selectedCert, setSelectedCert] = useState(null);



  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    source_url: "",
  });

  useEffect(() => {
    // Store landing page URL
    const existingSource = sessionStorage.getItem("source_url");
    if (!existingSource) {
      const landingUrl = window.location.href;
      sessionStorage.setItem("source_url", landingUrl);
      setFormData((prev) => ({
        ...prev,
        source_url: landingUrl,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        source_url: existingSource,
      }));
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email) {
      toast.error("Please enter your email");
      return;
    }

    try {
      setLoading(true);
      const response = await fetch(`${BaseUrl}/api/newsletter/store`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (result.error === false) {
        navigate("/thank-you");
      } else {
        toast.error(result.message || "Failed to subscribe.");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong while submitting the form.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let loaded = false;

    const loadChatWidgets = () => {
      if (loaded) return;
      loaded = true;

      if (!document.getElementById("freshworks-chat")) {
        const freshworksScript = document.createElement("script");
        freshworksScript.id = "freshworks-chat";
        freshworksScript.src = "https://in.fw-cdn.com/32179178/1163192.js";
        freshworksScript.defer = true;
        freshworksScript.setAttribute("chat", "true");
        document.body.appendChild(freshworksScript);
      }

      const botScriptId = "messenger-widget-b";
      const existingScript = document.getElementById(botScriptId);

      if (!existingScript) {
        const script = document.createElement("script");
        script.id = botScriptId;
        script.src = "https://cdn.botpenguin.com/website-bot.js";
        script.defer = true;
        script.innerHTML = "69a95e6cb9b10504e48e9e9b,67e69f485e9baf2f1bca5158";
        document.body.appendChild(script);
      }
    };

    if (pathname === "/") {
      window.addEventListener("scroll", loadChatWidgets, { once: true, passive: true });

      return () => {
        window.removeEventListener("scroll", loadChatWidgets);
      };
    }

    const events = ["pointerdown", "keydown", "touchstart", "scroll"];
    events.forEach((eventName) => {
      window.addEventListener(eventName, loadChatWidgets, { once: true, passive: true });
    });
    const fallbackTimer = window.setTimeout(loadChatWidgets, 30000);

    return () => {
      window.clearTimeout(fallbackTimer);
      events.forEach((eventName) => {
        window.removeEventListener(eventName, loadChatWidgets);
      });
    };
  }, [pathname]);


  useEffect(() => {
    const updateAlt = () => {
      document
        .querySelectorAll('img[src*="cdn.botpenguin.com"]')
        .forEach((img) => {
          img.setAttribute("alt", "AI Chat Assistant");
        });
    };
    updateAlt();
    const observer = new MutationObserver(updateAlt);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
    return () => observer.disconnect();
  }, []);

  const certificates = [

    {
      id: 1,
      logo: "/assets/images/ISO-2022.webp",
      image: "/assets/images/mi-certificate.webp",
      Gradienttitle: "ISO 9001:2015",
      title: "Certification",
      description: [
        "The ISO 9001:2015 certification is a distinguished accolade awarded to organisations that exemplify superior quality management practices. This esteemed international standard serves as a benchmark for entities aspiring to enhance their operations through the adoption of a robust quality management system, ensuring a continuous trajectory of quality improvement.",
        "Mobility Infotech proudly possesses the esteemed ISO 9001:2015 certification, a testament to our unwavering commitment to delivering exceptional service quality. Our dedication to rigorous quality control is paramount, and we continuously endeavour to elevate our visibility in recognition of our relentless pursuit of excellence."
      ],
    },


    {
      id: 2,
      logo: "/assets/images/ISO-2015.webp",
      image: "/assets/images/mi-certificate-2.webp",
      Gradienttitle: "ISO/IEC 27001:2022 ",
      title: "Certification",
      description: [
        "The ISO/IEC 27001:2022 certification is a distinguished accolade granted to organizations that demonstrate exceptional quality management practices. This globally recognized standard provides a framework for organizations aiming to improve their operations by establishing a strong quality management system, ensuring that quality continually develops and enhances over time.",
        "Mobility Infotech is proud to hold the esteemed ISO/IEC 27001:2022 certification, highlighting our steadfast commitment to providing superior service quality. Our dedication to stringent quality control is essential, and we consistently strive to increase our visibility in acknowledgment of our ongoing quest for excellence."
      ],
    },


    {
      id: 3,
      logo: "/assets/images/gdpr-compliance.webp",
      image: "",
      Gradienttitle: "",
      title: "",

    },

  ];


  return (
    <>
      <div className="footer-top">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-4">
              <div className="global-arrow"><img src="/assets/images/footer-arrow.webp" alt="Logo" /> </div>
            </div>
            <div className="col-md-8">
              <div className="global-text">
                <div className="heading">
                  Smarter Routes, Faster Deliveries. <strong> AI-Driven Route Planning That Adapts to Your <br/>Fleet in Real Time, Across Every Industry. </strong>
                </div>
                <Link className="theme-btn" to={"/contact-us"}> <span>See ai in action</span>{" "} </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer className="footer">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-lg-4">
              <div className="footer-logo-wrapper">
                <div className="footer-logo">
                  <Link to={"/"}> <img src="/assets/images/header-logo.webp" alt="Logo" /> </Link>
                </div>
                <div className="footer-subscription">
                  <p className="subtitle-text"> Get the latest localisation news & tips </p>

                  <form onSubmit={handleSubmit}>
                    <fieldset className="fieldInput">
                      <input className="form-input required form-control" name="email" type="email" value={formData.email}
                        onChange={handleChange} placeholder="Your email address*" />
                      <button disabled={loading} type="submit" className="form-submit theme-btn">
                        <span>{loading ? "Submitting..." : "Subscribe"}</span>
                      </button>
                    </fieldset>
                  </form>

                  <div className="footer-links">
                    <div className="heading">Certificates:</div>
                    <div className="certifications-logos">
                      {certificates.map((cert) => (
                        <span key={cert.id} onClick={cert.id !== 3 ? () => {
                          setSelectedCert(cert);
                          setShow(true);
                        } : undefined}  >
                          <img loading="lazy" src={cert.logo} alt="certificate" />
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-1 d-none d-lg-block"></div>

            <div className="col-md-12 col-lg-7">
              <div className="link-sec">
                <div className="row">
                  <div className="col-6 col-sm-6 col-md-4">
                    <div className="footer-link">
                      <div className="title">Solutions </div>
                      <ul>
                        <li>  <Link className="link-items" to={"/warehouse-management-system-wms"}> Warehouse Management </Link>    </li>
                        <li>  <Link className="link-items" to={"/route-optimization-and-planning"}> Route Optimization</Link>    </li>
                        <li>  <Link className="link-items" to={"/first-mile-logistics"}> First Mile Pickup </Link>   </li>
                        <li>  <Link className="link-items" to={"/middle-mile-logistics"}> Mid Mile </Link>   </li>
                        <li>   <Link className="link-items" to={"/transportation-management-services-tms"}> TMS Integration </Link></li>
                        <li>   <Link className="link-items" to={"/last-mile-delivery-logistics"}> Last Mile Delivery </Link>   </li>
                        <li>   <Link className="link-items" to={"/shipment-tracking"}> Shipment Tracking </Link>   </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-6 col-sm-6 col-md-4">
                    <div className="footer-link">
                      <div className="title">Industries </div>
                      <ul>
                        <li> <Link to="/post-parcel-carriers-software">Post & Parcel Carriers</Link>       </li>
                        <li>  <Link to="/retail-quick-commerce-solutions">Retail - Quick Commerce</Link>     </li>
                        <li> <Link to="/freight-management-solutions">Freight Forwarders</Link> </li>
                        <li>  <Link to="/process-manufacturing-logistics-solutions">Process Manufacturing</Link> </li>
                        <li> <Link to="/grocery-delivery-management-software">Groceries Commerce</Link>  </li>
                        <li>  <Link to="/automotive-supply-chain-platform">Automotive Industry</Link>   </li>
                        <li> <Link to="/consumer-goods-logistics-platform">Consumer Goods</Link>  </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-4">
                    <div className="footer-col">
                      <div className="footer-link">
                        <div className="title">Company </div>
                        <ul>
                          <li> <Link to={"/about-us"} className="link-items"> About Us </Link>    </li>
                          {/* <li> <Link className="link-items" onClick={openQueryModal}> Book A demo</Link> </li> */}
                          <li> <Link to={"/contact-us"} className="link-items"> Contact Us </Link>{" "} </li>
                          <li> <Link className="link-items" to={"/blogs"}> Blogs </Link>  </li>
                          <li><Link to="/case-study">Case Studies</Link></li>
                          <li><Link to="/media">Media</Link></li>
                        </ul>
                      </div>

                      <div className="footer-link resource-link">
                        <div className="title">Resources</div>
                        <ul>
                          <li> <Link className="link-items" to={"/pricing"}> RO Pricing</Link>    </li>
                          <li> <Link className="link-items" to={"/route-optimization-features"}> RO Features</Link>   </li>
                          <li> <Link className="link-items" to={"/calculator"}> RO ROI Calculator</Link>  </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-sm-12 col-md-7 col-lg-5">
              <div className="footer-logos">
                <Link to="https://www.g2.com/products/mobility-infotech/reviews#reviews" target="_blank"
                  rel="nofollow noopener noreferrer">
                  <img src="/assets/images/footer-company-11.webp" alt="Logo" className="img-responsive" />
                </Link>
                <Link to="https://clutch.co/profile/mobility-infotech" target="_blank"
                  rel="nofollow noopener noreferrer">
                  <img src="/assets/images/footer-company-5.webp" alt="Logo" className="img-responsive" />
                </Link>
                <Link><img src="/assets/images/footer-company-9.webp" alt="Logo" className="img-responsive" /></Link>
                <Link><img src="/assets/images/footer-company-1.webp" alt="Logo" className="img-responsive" /></Link>
                {/* <Link><img src="/assets/images/footer-company-2.webp" alt="Logo" className="img-responsive" /></Link>
                <Link><img src="/assets/images/footer-company-4.webp" alt="Logo" className="img-responsive" /></Link>
                <Link><img src="/assets/images/footer-company-6.webp" alt="Logo" className="img-responsive" /></Link>
                <Link><img src="/assets/images/footer-company-7.webp" alt="Logo" className="img-responsive" /></Link>
                <Link><img src="/assets/images/footer-company-8.webp" alt="Logo" className="img-responsive" /></Link>
                <Link><img src="/assets/images/footer-company-10.webp" alt="Logo" className="img-responsive" /></Link> */}
              </div>
            </div>
          </div>
          <div className="row justify-content-center">

            <div className="col-md-3">
              <div className="footer-address">
                <div className="title">US Address:</div>
                <p>16192 Coastal Highway, Lewes, Delaware 19958, County of Sussex</p>
              </div>
            </div>



            <div className="col-md-3">
              <div className="footer-address">
                <div className="title">Taiwan Address:</div>
                <p> 16F, No. 19, Alley 31, Lane 743, Section 5, Zhongxiao East Road, Xinyi District, Taipei City,
                  Taiwan</p>
              </div>
            </div>

            <div className="col-md-3">
              <div className="footer-address">
                <div className="title">India Address:</div>
                <p> Plot No. 51-52, Phase IV, Udyog Vihar, Sector 18, Gurugram, Haryana 122015</p>
              </div>
            </div>

            <div className="col-md-3">
              <div className="footer-address">
                <div className="title">Italy Address:</div>
                <p>Viale D’Agostino 51, Imola (BO) 40026</p>
              </div>
            </div>
          </div>
          <div className="footer-border"></div>
          <div className="row copyright-bottom">
            <div className="col-md-4 col-lg-4">
              <div className="footer-country-wrap">
                <div><img src="/assets/images/footer-country-3.webp" alt="country" className="img-responsive"
                  loading="lazy" /></div>
                <div><img src="/assets/images/footer-country-4.webp" alt="country" className="img-responsive"
                  loading="lazy" /></div>
                <div><img src="/assets/images/footer-country-2.webp" alt="country" className="img-responsive"
                  loading="lazy" /></div>
                <div><img src="/assets/images/footer-country-1.webp" alt="country" className="img-responsive"
                  loading="lazy" /></div>
              </div>
            </div>
            <div className="col-md-3  col-lg-4">
              <div className="footer-social">
                <ul className="social-items">
                  <li>
                    <Link to={"https://www.facebook.com/profile.php?id=61565074738395"} target="_blank"> <i
                      className="fab fa-facebook-f"></i></Link>
                  </li>
                  <li>
                    <Link to={"https://www.instagram.com/mobility_infotech/"} target="_blank"><i
                      className="fab fa-instagram"></i></Link>
                  </li>
                  <li>
                    <Link to={"https://www.linkedin.com/company/mobility-infotech-pvt-ltd/"} target="_blank"> <i
                      className="fa-brands fa-linkedin-in"></i> </Link>
                  </li>
                  <li>
                    <Link to={"https://www.youtube.com/@MobilityInfotech"} target="_blank"> <i className="fab fa-youtube"></i>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-5 col-lg-4">
              <div className="copyright-link">
                <Link to={"/privacy-policy"}>Privacy Policy</Link>
                <Link to={"/privacy-policy?tab=conditions"}>Terms & Condition</Link>
              </div>
            </div>

            <div className="col-md-12 col-lg-12">
              <div className="copyright-text-new">
                <p>Copyright © {new Date().getFullYear()} Togopool Pvt.Ltd. All rights reserved. Designed by  <Link target="_blank" rel="noopener noreferrer" to="https://www.88gravity.com/"> 88gravity.</Link></p>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <Modal className="certificate-info-popup" show={show} onHide={() => setShow(false)} centered >
        <Modal.Body>
          <button type="button" className="btn-close" onClick={() => setShow(false)}
            aria-label="Close" ></button>
          {selectedCert && (
            <div className="row align-items-center">
              <div className="col-lg-5 col-md-5">
                <div className="modal-certificate">
                  <img className="img-responsive" src={selectedCert.image} alt="certificate" />
                </div>
              </div>
              <div className="col-lg-7 col-md-7">
                <div className="modal-certificate-content">
                  <h5 className="heading">
                    <span className="gradiant-color"> {selectedCert.Gradienttitle} </span> {selectedCert.title}
                  </h5>
                  {selectedCert?.description.map((para, index) => (<p key={index}>{para}</p>))}
                </div>
              </div>
            </div>
          )}
          <img className="img-responsive certificate-vector" src="/assets/images/certificate-vec.webp" alt="certificate"
            loading="lazy" />
        </Modal.Body>
      </Modal>
    </>
  );
}
